import * as _ from 'underscore';

let SolrSuggest = function (el) {
    this.initialize(el);
};

SolrSuggest.prototype.initialize = function (el, attributes) {
    let $el = $(el);
    let dataset = $el.data();

    this.$el = $el;
    this.$textInput = $el.find(dataset.inputselector || '[data-input]');
    this.$resultsWrapper = $el.find('[data-results]')
    this.jsonServiceUrl = dataset.solrurl || window.tx_solr_suggestUrl || '/suggest.json';

    this.$textInput.on('input', function (e) {
        let val = this.$textInput.val();

        if (val.length > 2) {
            this.getResults(val);
        } else {
            this.removeResultItems();
        }
    }.bind(this));

    this.$textInput.on('keydown', function (e) {
        if (40 === e.which) {
            if (this.$resultsWrapper[0].firstChild) {
                this.$resultsWrapper[0].firstChild.focus();
            }
        }
    }.bind(this));

    return this;
};

SolrSuggest.prototype.getResults = function (val) {
    let self = this;
    let req = $.ajax({
        url: this.jsonServiceUrl,
        dataType: 'json',
        data: {
            "tx_solr[queryString]": val.toLowerCase()
        },
        success: function (data) {
            self.removeResultItems();

            _.each(data.suggestions, function (key, val) {
                var itemData = {
                    id: key,
                    label: val
                };

                self.appendResultItem(itemData)
            });

            self.$resultsWrapper.find('a').on('keydown', function (e) {
                switch (e.which) {
                    case 38: // up
                        if (e.target.previousSibling) {
                            e.target.previousSibling.focus();
                        }
                        break;

                    case 40: // down
                        if (e.target.nextSibling) {
                            e.target.nextSibling.focus();
                        }
                        break;

                    default:
                        return; // exit this handler for other keys
                }
                e.preventDefault(); // prevent the default action (scroll / move caret)
            }.bind(this));
        }
    });

    return req;
};

SolrSuggest.prototype.removeResultItems = function () {
    this.$resultsWrapper.html('');

    return this;
};

SolrSuggest.prototype.appendResultItem = function (itemData) {
    let $itemEl = $('<li />');
    $itemEl.attr('id', itemData.id);
    $itemEl.html(itemData.label);
    $itemEl.on('click', this.onResultsClick.bind(this));

    this.$resultsWrapper.append($itemEl);

    return this;
};

SolrSuggest.prototype.onResultsClick = function (e) {
    let $selectedEl = $(e.target);
    let searchQuery = $selectedEl.html();

    e.preventDefault();
    e.stopImmediatePropagation();

    this.$textInput.val(searchQuery);
    this.$el.submit();

    return this;
};

export default SolrSuggest;
